import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const APPOINTMENT_PATH = "/appointment/v1";

// appointment

export const getAppointmentApi = async (params, options = {}) => await getRequest(APPOINTMENT_PATH, params, options);

export const getAppointmentByIdApi = async (params, options = {}) => await getRequest(`${APPOINTMENT_PATH}/${params?.id}`);

export const addAppointmentApi = async (body) =>
  await postRequest(APPOINTMENT_PATH, body);

export const updateAppointmentApi = async (body) =>
  await putRequest(`${APPOINTMENT_PATH}/${body?._id}`, body);

export const deleteAppointmentByIdApi = async (id) =>
  await deleteRequest(`${APPOINTMENT_PATH}/${id}`);

// reschedule appointment
export const rescheduleAppointmentApi = async (params, body) =>
  await putRequest(`${APPOINTMENT_PATH}/reschedule/${params?.id}`, body);

// cancel appointment
export const cancelAppointmentApi = async (params) =>
  await putRequest(`${APPOINTMENT_PATH}/cancel/${params?.id}`);
